var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.308v1.23m0 0c0 .653.26 1.28.721 1.741M4 17.539l.721 1.74m0 0a2.461 2.461 0 001.74.721m-1.74-.721l1.74.721m0 0H17.54m0 0c.652 0 1.278-.26 1.74-.721m-1.74.721l1-.212.74-.509m0 0a2.461 2.461 0 00.721-1.74m-.721 1.74l.721-1.74m0 0v-1.231M8.308 10.769L12 15.077m0 0l3.692-4.308M12 15.077V4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDownload;